import IntegrationOverview from '../../../../../components/integration-overview/IntegrationOverview';
import { Entity } from '../../../../../types/entity';
import FYILogo from '../../../../../assets/fyi.png';
import FYIDocsEntityConfiguration from './FYIDocsEntityConfiguration';
import { useFirmContext } from '../../../../../providers/FirmProvider';
import { Link } from 'react-router-dom';

import FYIEntityFileSelect from './FYIEntityFileSelect/FYIEntityFileSelect';
import { Button, Input, InputV2 } from '@cimplico/components';
import DocumentResync from './DocumentResync';
import FYIDisconnect from './FYIDisconnect';

type EntityFYIDocsIntegrationProps = {
    entity: Entity;
};
function EntityFYIDocsIntegration({ entity }: EntityFYIDocsIntegrationProps): JSX.Element {
    const firm = useFirmContext();
    const { fyi } = entity.integrations;
    const allowedFYI = firm.allowedIntegrations?.includes('fyi');

    return (
        <IntegrationOverview
            title="FYI"
            description="Pull your documents, clients and groups from FYI."
            active={Boolean(fyi)}
            logo={FYILogo}
            comingSoon={!allowedFYI}
            supportLink="https://learn.cimplico.com/docs/fyi-files#managing-the-fyi-connection-to-an-entity"
        >
            <div className="mt-2">
                {/* Has the firm setup FYI */}
                {!firm.integrations.fyi ? (
                    <p className="text-sm text-gray-700">
                        Please setup your FYI Docs credentials on the{' '}
                        <Link to={'../../settings?tab=integrations&focusedIntegration=fyi'} className="text-indigo-600 underline">
                            firm settings page
                        </Link>
                        .
                    </p>
                ) : (
                    <div>
                        {/* Configure FYI entity */}
                        {!fyi && <FYIDocsEntityConfiguration entity={entity} />}

                        {/* Select FYI Documents */}
                        {fyi && (
                            <div className="max-w-[500px] gap-8 grid">
                                <div className="grid gap-2">
                                    <p className="text-sm text-gray-800 font-medium">Connected entity</p>
                                    <Input value={fyi.name} disabled title="Connected FYI entity" type="text" />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-800 font-medium mb-1">Cabinet select</p>
                                    <label className="text-sm text-gray-600 block mb-2">
                                        Select documents from other cabinets to add to the entity.
                                    </label>
                                    <FYIEntityFileSelect id={fyi.id} name={fyi.name} entityId={entity.id} />
                                </div>
                                <DocumentResync entityId={entity.id} />
                                {/* Remove button */}
                                <FYIDisconnect entity={entity} />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </IntegrationOverview>
    );
}
export default EntityFYIDocsIntegration;
